import { styled } from "@linaria/react"

const Skeleton = styled.div<Props>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "1rem"};
  border-radius: ${(props) => props.borderRadius || "4px"};
  background: rgb(138, 145, 158, 0.17);
  background-image: linear-gradient(
    to right,
    rgb(138, 145, 158, 0.095) 0%,
    rgb(138, 145, 158, 0.075) 25%,
    rgb(138, 145, 158, 0.175) 50%,
    rgb(138, 145, 158, 0.075) 75%,
    rgb(138, 145, 158, 0.095) 100%
  );
  background-repeat: no-repeat;
  animation-name: shime;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;

  @keyframes shime {
    0% {
      background-position: -600px 0;
    }
    100% {
      background-position: 600px 0;
    }
  }
`

interface Props {
  width?: string
  height?: string
  borderRadius?: string
}

export default Skeleton
